<template>
	<div>
		<div style="height:25px; padding:10px; font-size:16px" id="jobInfoText"></div>
		<layout-2 :id=pageid :navbar=true :title="'Edit Job Schedule'" :use_radio=false :term=term style="width:100%; height:calc(100vh - 75px);"></layout-2>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.EDIT_JOB_SCHEDULES_PAGE,
			pageid2:PAGES.SCHEDULE_JOB_INFO,
		}
	},
	async created () {
		this.getJobData()
	},
	methods: {
		getJobData(){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid2,
						data:[
							this.term
						],
					}
				}
			).then((res) => {
				var text = ""
				for(var i = 0;i<res.data.data.column_names.length;i++){
					text+="<b>"+res.data.data.column_names[i]+":</b> "
					text+=res.data.data.column_data[0][i]+"&emsp;"
				}
				document.getElementById("jobInfoText").innerHTML = text;
			});
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/edit/Edit_Job_Schedules.vue